import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { Container } from 'semantic-ui-react';
import useActivity from '../hooks/activity/useActivity';
import ActivityDetails from '@components/activity/ActivityDetails';
import { ActivityDurationParse } from '@utils/constants';
import { Descriptions, Card, Row, Col, Image } from 'antd';
import * as config from '@config';
import BackBar from '@components/BackBar';
import useMediaQuery from '@hooks/useMediaQuery';
import { max } from 'date-fns';

function ActivityViewPage() {
    const { id } = useParams();
    const {
        fetching,
        fetchActivity,
        data: { activity = {} },
        abort,
    } = useActivity();
    const { larger, smaller } = useMediaQuery({ maxWidth: 700 });

    useEffect(() => {
        console.log(id);
        fetchActivity(id).catch((error) => {
            console.error('Error fetching activity:', error);
            alert(error);
        });
        return () => {
            abort();
        };
    }, [id]);

    const renderDuration = () => {
        if (!activity.duration) {
            return null;
        }
        return (
            <Card style={{ marginBottom: '16px' }}>
                <Descriptions column={1}>
                    <Descriptions.Item label={'时长'}>
                        {ActivityDurationParse(activity.duration) || 'N/A'}
                    </Descriptions.Item>
                </Descriptions>
            </Card>
        );
    };

    const renderPhotoGrid = () => {
        if (!activity.photos || activity.photos.length === 0) {
            console.log('No photos');
            return null;
        }

        return (
            <Card>
                <Row gutter={[8, 8]}>
                    {activity.photos.map((photo, index) => (
                        <Col xs={8} sm={6} md={10} key={photo.id}>
                            <div>
                                <Image
                                    alt={`Photo ${index + 1}`}
                                    src={`${config.baseURL}/public/${photo.filename}`}
                                    preview={{ src: `${config.baseURL}/public/${photo.filename}` }}
                                    style={{
                                        objectFit: 'cover',
                                        aspectRatio: '1/1',
                                    }}
                                />
                            </div>
                        </Col>
                    ))}
                </Row>
            </Card>
        );
    };

    return (
        <div>
            <Container>
                <div className="gap"></div>
                <BackBar />
                <div className="gap"></div>
                {fetching && <p>Loading...</p>}
                <div style={{ fontSize: '20px', fontWeight: '500' }}>{activity.name}</div>
                <div className="gap"></div>
                <div style={{ display: 'flex', gap: '16px', flexDirection: smaller ? 'column' : 'row' }}>
                    <div style={{ flex: 2 }}>
                        <ActivityDetails activity={activity} />
                    </div>
                    <div style={{ flex: 1 }}>
                        {renderPhotoGrid()}
                        <div className="gap"></div>
                        {renderDuration()}
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default ActivityViewPage;
